/**
 * beforeUnmountHook.ts
 * App.vue onBeforeUnmount() の本体
 * App.vue から切り出し
 */

type VM = any

export function onBeforeUnmount(vm: VM) {
window.removeEventListener("resize", vm.onResize);
vm.cancelShortUrlTimer();

// Android用touchイベントリスナーのクリーンアップ
if (vm.s_isAndroid && vm.stopOnMenu) {
  window.removeEventListener('touchstart', vm.stopOnMenu, { capture: true });
  window.removeEventListener('touchmove', vm.stopOnMenu, { capture: true });
  window.removeEventListener('touchend', vm.stopOnMenu, { capture: true });
  vm.stopOnMenu = null;
}
if (vm.s_isAndroid && vm.stopOnContent) {
  window.removeEventListener('touchstart', vm.stopOnContent, { capture: true });
  window.removeEventListener('touchmove', vm.stopOnContent, { capture: true });
  window.removeEventListener('touchend', vm.stopOnContent, { capture: true });
  vm.stopOnContent = null;
}

// iOS向けチューニングのクリーンアップ
if (vm.iosTuningCleanup && typeof vm.iosTuningCleanup === 'function') {
  try { vm.iosTuningCleanup(); } catch (_) {}
  vm.iosTuningCleanup = null;
}

// メモリ監視の停止
if (vm.memoryMonitorCleanup && typeof vm.memoryMonitorCleanup === 'function') {
  try { vm.memoryMonitorCleanup(); } catch (_) {}
  vm.memoryMonitorCleanup = null;
}

// メモリクリーンアップインターバルの停止
if (vm.memoryCleanupInterval) {
  clearInterval(vm.memoryCleanupInterval);
  vm.memoryCleanupInterval = null;
}

// 位置情報ポーリングタイマーの停止
if (vm.geoPollTimer) {
  clearInterval(vm.geoPollTimer);
  vm.geoPollTimer = null;
}

// 履歴記録インターバルの停止
if (vm.intervalId) {
  clearInterval(vm.intervalId);
  vm.intervalId = null;
}

// スケール/角度調整のインターバルの停止
try { vm.stopScaleUp(); } catch(_) {}
try { vm.stopScaleDown(); } catch(_) {}
try { vm.stopAnglePlus(); } catch(_) {}
try { vm.stopAngleMinus(); } catch(_) {}

// visibilitychangeリスナーの削除
if (vm.handleVisibilityChange) {
  document.removeEventListener('visibilitychange', vm.handleVisibilityChange);
  vm.handleVisibilityChange = null;
}

// コンテキストメニューのクリーンアップ
if (typeof vm.detachForContextMenu === 'function') {
  try { vm.detachForContextMenu(); } catch (_) {}
  vm.detachForContextMenu = null;
}

if (vm.mapSpeedTuners) {
  Object.keys(vm.mapSpeedTuners).forEach((key) => {
    const disposer = vm.mapSpeedTuners[key];
    if (typeof disposer === 'function') {
      try { disposer(); } catch (_) {}
    }
    vm.mapSpeedTuners[key] = null;
  });
}
}
